import { EulaSectionContent } from '../../../../common/components/EulaSection/EulaSection'
import { defaultNow } from '../../../../common/utils/dateTimeNow'
import { FormikProps, useFormikContext } from 'formik'
import { useEffect, useState } from 'react'
import { BoxV4, ExternalLink } from '@labrav/react-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './EulaSectionCombinedForm.styles'
import { CombinedFormState } from '../../../../modules/combinedForm/reducer'
import { HelpDrawer } from '@labrav/common'

export const EulaSectionCombinedForm = ({
  receivedResaleAuthEulaUrl,
  disabled,
}: {
  receivedResaleAuthEulaUrl: string
  disabled: boolean
}) => {
  const { classes } = useStyles()
  const [eulaErr, setEulaErr] = useState<string>('')
  const updateErr = (error: string) => {
    setEulaErr(error)
  }
  const formikProps = useFormikContext() as FormikProps<CombinedFormState>
  const { values, touched, errors, setFieldValue } = formikProps
  useEffect(() => {
    const eulaFile = values?.cppoData?.eulaFile as unknown
    const fileCount =
      eulaFile && typeof (eulaFile as { length?: number }).length === 'number'
        ? (eulaFile as { length: number }).length
        : 0
    if (fileCount > 0) {
      setFieldValue('cppoData.eulaType', 'CUSTOM')
    } else {
      setFieldValue('cppoData.eulaType', 'STANDARD')
    }
  }, [values?.cppoData?.eulaFile?.length, setFieldValue])

  return (
    <>
      <div data-testid="combined-form-resale-auth-eula">
        <BoxV4
          heading={'End-user License Agreement (EULA)'}
          headingIcon={
            <FontAwesomeIcon
              icon={faFileContract}
              style={{ width: '14px', height: '14px' }}
            />
          }
          secondaryActions={
            <HelpDrawer
              sectionName="combinedFormEULA"
              headerTitle="Help & FAQs"
            />
          }
        >
          <div className={classes.viewEulaContainer}>
            <p className={classes.viewEulaDescription}>
              ISV has provided an EULA for this reseller authorization. It will
              be presented to buyer alongside your EULA.{' '}
            </p>
            <ExternalLink
              className={classes.docsLink}
              href={receivedResaleAuthEulaUrl}
            >
              View EULA
            </ExternalLink>
          </div>
        </BoxV4>
      </div>
      <div data-testid="channel-offer-eula-uploader">
        <BoxV4
          heading={'Attach your EULA for buyer'}
          headingIcon={
            <FontAwesomeIcon
              icon={faFileContract}
              style={{ width: '14px', height: '14px' }}
            />
          }
          secondaryActions={
            <HelpDrawer
              sectionName="combinedFormAttachEULAForBuyer"
              headerTitle="Help & FAQs"
            />
          }
          isOptional
        >
          <EulaSectionContent
            defaultNow={defaultNow}
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            isMultiFileUpload={true}
            fileUploadDescription={
              'Upload up to 5 files one by one, use plain text .txt or PDF formats only. The maximum file size is 10 MB.'
            }
            fileUploadButtonText={'Upload'}
            fileUploadContainerTitle={
              'Upload up to 5 PDF files. Drag and drop it here.'
            }
            quantity={5}
            eulaOptionsHeading={'Legal term documents'}
            isOptional={false}
            showEulaFileUpload={true}
            showEulaOptions={false}
            fileSize={10}
            updateErr={updateErr}
            uploadError={
              eulaErr ||
              (touched?.cppoData?.eulaFile ? errors?.cppoData?.eulaFile : '')
            }
            uploadFolderName="reseller_cppo_eula_files"
            eulaTypeKeyName={'cppoData.eulaType'}
            eulaFilesKeyName={'cppoData.eulaFile'}
            disableEulaFileUpload={disabled}
            disabled={disabled}
            disableEulaOptions={disabled}
          />
        </BoxV4>
      </div>
    </>
  )
}
